var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("短信验证码")]),_vm._v(" "),_c('div',{staticClass:"demo-content"},[_c('div',{staticClass:"bx-btn",on:{"click":function($event){_vm.showSMS()}}},[_vm._v("显示短信验证码")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44350928","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MessageBox.vue
// module id = null
// module chunks = 